import { render } from "./HeroAddEventModalMain.vue?vue&type=template&id=3145202a&scoped=true"
import script from "./HeroAddEventModalMain.vue?vue&type=script&lang=js"
export * from "./HeroAddEventModalMain.vue?vue&type=script&lang=js"

import "./HeroAddEventModalMain.vue?vue&type=style&index=0&id=3145202a&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3145202a"]])

export default __exports__